import { FC } from 'react'
import styled from 'styled-components'
import Glass from 'components/Common/Glass'
import breakpoints from 'utils/consts/breakpoints'
import { getImageSrc } from 'utils/screen'
import {
  ProductViewBySlugQuery,
  ImageThumbnail64Fragment,
} from 'api/operations'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and ${breakpoints.device.tablet}, ${breakpoints.device.mobile} {
    position: absolute;
    left: 0;
    bottom: 0;
  }
`

const List = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  @media screen and ${breakpoints.device.tablet}, ${breakpoints.device.mobile} {
    display: none;
  }
`

const ImageSelectButton = styled.button<{ isActive: boolean }>`
  appearance: none;
  background: none;
  margin: 0;
  border: 1px solid;
  border-radius: 8px;
  width: 80px;
  height: 80px;
  padding: 7px;
  cursor: pointer;
  border-color: ${props => (props.isActive ? '#717284' : '#E7E7EA')};
`

const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  box-sizing: border-box;
`

const GlassWrapper = styled.div`
  display: flex;
`

interface BottomProps {
  images: ImageThumbnail64Fragment[]
  product: ProductViewBySlugQuery['productBySlug']
  selectedImage: number
  setSelectedImage: (index: number) => void
}

const Bottom: FC<BottomProps> = props => {
  const { images, product, selectedImage, setSelectedImage } = props

  const type = product?.wine?.wineType?.id
  const color = product?.wine?.wineColor?.id

  return (
    <Wrapper>
      <GlassWrapper>
        {(selectedImage === 0 || images.length === 0) && (
          <Glass color={color} type={type} size='big' />
        )}
      </GlassWrapper>

      <List>
        {images.map((item, index) => (
          <ImageSelectButton
            key={index}
            onClick={() => setSelectedImage(index)}
            isActive={index === selectedImage}
          >
            <ImagePreview {...getImageSrc(item)} />
          </ImageSelectButton>
        ))}
      </List>
    </Wrapper>
  )
}

export default Bottom
